import axios from "axios";
import { headersProvider } from "../pages/utilities";

export const getAttacchedFiles =async ({id})=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/attachedfiles/${id}`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error logging in!", error);
    throw error;
  });
}


  export const attachFiles =async ({body})=>{
    return axios.post(`${process.env.REACT_APP_API_URL}/attachfiles`, {...body },{
      headers: headersProvider(),
    })
    .then(response => response.data)
    .catch(error => {
      console.error("There was an error attaching file", error);
      throw error;
    });
  }

  export const getFile = async({id}) =>{
    return axios.post(`${process.env.REACT_APP_API_URL}/getfile`,{id},{
      headers: headersProvider(),
    })
    .then(response => response.data)
    .catch(error =>{
      console.error("There was an error getting file", error);
      throw error;
    });
  }

  export const attachFileToParent =async({extension, contentType})=>{
    return axios.post(`${process.env.REACT_APP_API_URL}/attach-file-to-parent`,  {extension, contentType},{
      headers: headersProvider(),
    })
    .then(response => response.data)
    .catch(error=>{
      console.error("There was an error attaching file", error);
      throw error;
    })
  }


  export const getReadUrl = async({hostedLink })=>{
    return axios.post(`${process.env.REACT_APP_API_URL}/getreadurl`,  {hostedLink},{
      headers: headersProvider(),
    })
    .then(response => response.data)
    .catch(error=>{
      console.error("There was an error getting read url", error);
      throw error;
    })
  }

  
  // Get anonymous sharing link with expiration for AI services
  // Currently only used for ms files
  export const getAIAccessUrl = ({ hostedLink }) =>
  axios.get(`${process.env.REACT_APP_API_URL}/ai-access-url`, {
    params: {
      hostedLink,
    },
    headers: headersProvider(),
  });


  export const deleteFile = async ({id})=>{
    return axios.post(`${process.env.REACT_APP_API_URL}/deleteFile`, {id},{
      headers: headersProvider(),
    })
    .then(response => response.data)
    .catch(error=>{
      console.log("there was an errror deleting file ", error);
    })
  }